<div class="form-group gw-relative">
  <div class="gw-flex gw-flex-col gw-h-[72px]">
    <label class="gw-form-label gw-h-[16px]">
      {{ label }}
      <span *ngIf="required" class="gw-text-status-negative">*</span>
    </label>

    <div class="gw-input-group">
      <tui-textfield class="gw-w-full">
        <input
          tuiInputDateRange
          [formControl]="control"
          [min]="minDate"
          [max]="maxDate"
          [disabled]="disabled"
          class="datepicker-range hover:gw-bg-background-neutral-1-hover"
        />

        <tui-calendar-range
          *tuiTextfieldDropdown
          [min]="minDate"
          [max]="maxDate"
        />
      </tui-textfield>
    </div>
  </div>
</div>
